<template>
  <div>
  <L1 :style="{zIndex: 10}" :popup0="!!selected" :popup="tables">
    <template slot="slot_title">
      <Select :defaultValue="area" @input="area=$event" :width="'165px'">
        <option :value="null">全部區域</option>
        <option v-for="(rest, r) in restaurants" :key="`rest-${r}`" :value="rest" >{{rest}}</option>
      </Select>
      <Select :defaultValue="isUpload" @input="isUpload=$event" :width="'135px'">
        <option :value="null">全部</option>
        <option v-for="(rest, r) in ['發票開立', '已上傳', '未上傳']" :key="`rest-${r}`" :value="rest" >{{rest}}</option>
      </Select>
      <R1 id="green" :options="['總計', '細節']" :defaultValue="folded" @input="folded=$event"></R1>
      <DateSelect :defaultValue="range" @input="range=$event"/>
      <Search :defaultValue="searchText" @input="searchText=$event" :width="'230px'"/>
      <Search :defaultValue="serialNo" @input="serialNo=(parseInt($event)||null)" :placeholder="'交易序號'" :width="'160px'"/>
      <sqr40016  :bg="'var(--color-checked)'" :icon="'sync'" :text="'上傳發票'" @click="uploadInvs" :style="{marginLeft: 'auto'}"/>
    </template>
    <Table :rows="rows" :style="{marginInline: '16px 28px'}">
      <template slot="slot_head">
        <th :style="{textAlign: 'start', width: '130px'}">交易時間</th>
        <th :style="{textAlign: 'center', width: '100px'}">交易序號</th>
        <th :style="{textAlign:'center', width: '84px'}">機號</th>
        <th :style="{textAlign: 'center', width: '100px'}">型態</th>
        <th :style="{textAlign: 'start', width: '160px'}">發票號碼</th>
        <th :style="{textAlign: 'center', width: '60px'}">列印</th>
        <th :style="{textAlign: 'center', width: '120px'}">支付方式</th>
        <th :style="{textAlign: 'start', width: '200px'}">銷售數量</th>
        <th :style="{textAlign: 'start', width: '180px'}">會員ID</th>
        <th :style="{textAlign:'center', width: '104px'}">折扣</th>
        <th :style="{textAlign:'center', width: '104px'}">禮券</th>
        <th :style="{textAlign: 'end', width: '130px'}">(總)發票金額</th>
        <th :style="{textAlign: 'end', width: '150px', paddingRight: '30px'}">發票稅額</th>
      </template>
      <template slot-scope="{item,index}">
        <template v-if="item.inv&&item.inv.length>0">
        <tr v-for="(inv, i) in item.inv"  @click="selected=item._id===(selected?._id)?null:item" :class="item._id===selected?._id?'selected':''" :index="index" :key="`inv-${index}-${i}`"
        :style="[{
          minHeight: '100px',
          height: '100px'
        }, item.InvoiceNo&&!inv?.isUpload?{backgroundColor: '#CACACA99'}:{}]">
          <template v-if="i===0">
            <td :rowspan="item.inv.length" :style="{textAlign:'start', whiteSpace: 'nowrap'}" v-html="moment(item.paidTime).format('yyyy-MM-DD<br>HH:mm')"></td>
            <td :rowspan="item.inv.length">{{(item.serialNoCashier||item.serialNo).toString().padStart(4, 0)}}</td>
            <td :rowspan="item.inv.length" :style="{whiteSpace: 'nowrap'}" v-html="(item.cashierMachine||'').replaceAll('-', '<br>')"></td>
            <td :rowspan="item.inv.length" :style="{textAlign:'start'}">
              <div class="status" v-if="inv&&inv.InvoiceNo" :class="item?.status !== '已取消' ? '銷售' : inv.status ? inv.status : '-'">{{item?.status !== '已取消' ? '銷售' : (inv.status || '測試')}}</div>
            </td>
          </template>
          <td :style="[{textAlign:'start', paddingLeft:'10px'}, inv.status === '作廢' && {textDecoration: 'line-through'}]">{{inv.InvoiceNo}}</td>
          <td :style="{textAlign:'center'}">{{inv ?
          (inv.Print && parseInt(inv?.Print)) ? (inv.CustomerIdentifier && '統編') || 'O' :
          ((inv.CarrierNum && '載具') || (inv.LoveCode && '捐贈')) :
          ''}}</td>

          <template v-if="i===0">
            <td :rowspan="item.inv.length" :style="{textAlign:'center'}" v-html="[
            (item.payInfo?.ECR_Response_Code&&'信用卡') ||
            (item.payInfo?.Response_Code&&'電子支付') ||
            (item.payInfo?.AccountInfo&&'匯款') ||
            (item.cash&&'現金'), item.balance ? '點數' : null, ...Array.from(new Set((item.voucherCashInfo || []).map(e => e.name))), item.voucher ? '禮券' : null, item.overpaid ? '(溢收)' : null].filter(e => e).join('<br>')"></td>
            <td :rowspan="item.inv.length" :style="{textAlign:'start'}">品項x{{item.Orders.length}} 共{{fixCount(item.Orders.map(e => e.count).reduce((a, b) => a + b, 0))}}項</td>
            <td :rowspan="item.inv.length" :style="{textAlign:'start'}">{{item.memberID}}</td>
            <td :rowspan="item.inv.length" :style="{textAlign:'center', color: '#9EAF89'}">${{-1*item.disc}}</td>
            <td :rowspan="item.inv.length" :style="{textAlign:'center', color: '#9EAF89'}">${{-1*item.voucher}}</td>
            <td :rowspan="item.inv.length" :style="{textAlign:'end'}">${{(item.price) * 1}}</td>
            <td :rowspan="item.inv.length" :style="{textAlign:'end', paddingRight: '30px'}">${{((item.price) * (5/105)).toFixed(0)}}</td>
          </template>
        </tr>
        </template>
        <template v-else>
        <tr  @click="selected=item._id===(selected?._id)?null:item" :class="item._id===selected?._id?'selected':''" :index="index"
        :style="[{
          minHeight: '100px',
          height: '100px'
        }]">
          <td :style="{textAlign:'start', whiteSpace: 'nowrap'}" v-html="moment(item.paidTime).format('yyyy-MM-DD<br>HH:mm')"></td>
          <td>{{(item.serialNoCashier||item.serialNo).toString().padStart(4, 0)}}</td>
          <td :style="{whiteSpace: 'nowrap'}" v-html="(item.cashierMachine||'').replaceAll('-', '<br>')"></td>
          <td :style="{textAlign:'start'}">
            <div class="status" :class="item.status !== '已取消' ? '銷售' : '取消'">{{item.status !== '已取消' ? '銷售' : '交易取消'}}</div>
          </td>
          <td :style="{textAlign:'start'}"><span v-if="item.overpaid">(溢收 ${{item.overpaid}})</span></td>
          <td :style="{textAlign:'center'}"></td>
          <td :style="{textAlign:'center'}" v-html="[
            (item.payInfo?.ECR_Response_Code&&'信用卡') ||
            (item.payInfo?.Response_Code&&'電子支付') ||
            (item.payInfo?.AccountInfo&&'匯款') ||
            (item.cash&&'現金'), item.balance ? '點數' : null, ...Array.from(new Set((item.voucherCashInfo || []).map(e => e.name))), item.voucher ? '禮券' : null, item.overpaid ? '(溢收)' : null].filter(e => e).join('<br>')"></td>
          <td :style="{textAlign:'start'}">品項x{{item.Orders.length}} 共{{fixCount(item.Orders.map(e => e.count).reduce((a, b) => a + b, 0))}}項</td>
          <td :style="{textAlign:'start'}">{{item.memberID}}</td>
          <td :style="{textAlign:'center', color: '#9EAF89'}">${{-1*item.disc}}</td>
          <td :style="{textAlign:'center', color: '#9EAF89'}">${{-1*item.voucher}}</td>
          <td :style="{textAlign:'end'}">${{(item.price) * 1}}</td>
          <td :style="{textAlign:'end', paddingRight: '30px'}">${{((item.price) * (5/105)).toFixed(0)}}</td>
        </tr>

        </template>
        <template v-if="folded==='細節'">
          <tr v-for="(order, o) in item.Orders" :key="`${index}-${o}`" :style="{backgroundColor: '#f3f3f3'}">
            <td></td>
            <td>{{(o+1).toString().padStart(4, 0)}}</td>
            <td></td>
            <td class="status" v-if="inv" :class="inv.status === '開立' ? '銷售' : '作廢'">{{inv.status === '開立' ? '銷售' : '作廢'}}</td>
            <td class="status" v-else :class="item.status !== '已取消' ? '銷售' : '取消'">{{item.status !== '已取消' ? '銷售' : '作廢'}}</td>
            <td :style="{textAlign:'start'}" colspan="3">{{order.name}}</td>
            <td :style="{textAlign:'start'}">${{order.price + order.items.map(e => (e.priceDiff||0) + (e.add||[]).map(a => a.price).reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0)}}x{{order.count}}</td>
            <td v-if="o===0"></td>
            <td v-else></td>
            <td></td>
            <td></td>
            <td :style="{textAlign:'end'}">${{(order.price + order.items.map(e => (e.priceDiff||0) + (e.add||[]).map(a => a.price).reduce((a, b) => a + b, 0)).reduce((a, b) => a + b, 0)) * order.count}}</td>
            <td></td>
          </tr>

        </template>
      </template>
    </Table>
  </L1>
  <RecordBox :Reasons="Reasons" :style="{zIndex: 11}"  @remitUpdate="remitUpdate"
  :salesmans="salesmans"
  :projects="projects"
  @update="update" :item="selected" slot="popup0" @close="selected=null"/>
  </div>
</template>

<script>
import sqr40016 from '../../components/btn/sqr40016.vue'
import RecordBox from './recordDetail.vue'
import R1 from '../../components/radio/r1.vue'
import Table from '../../components/tables/t2.vue'
import Search from '../../components/input/search.vue'
import Select from '../../components/select.vue'
import DateSelect from '../../components/radio/date_Single_Range.vue'
import L1 from '../../components/layout/L1.vue'
import { getapi, postapi } from '../../store/fetch'
import { mapState } from 'vuex'
const VUE_APP_INVOICE = JSON.parse(process.env.VUE_APP_INVOICE)
export default {
  components: {
    sqr40016,
    L1,
    DateSelect,
    Search,
    Table,
    RecordBox,
    Select,
    R1
  },
  data () {
    return {
      VUE_APP_INVOICE,
      folded: '總計',
      status: null,
      type: null,
      area: null,
      isUpload: null,
      range: {
        start: this.moment().format('yyyy-MM-DD'),
        duration: 0,
        end: this.moment().format('yyyy-MM-DD')
      },
      searchText: null,
      serialNo: null,
      rows: [],
      selected: null,
      tables: false,
      projects: [],
      salesmans: [],
      Reasons: []
    }
  },
  computed: {
    ...mapState({
      statusList: 'statusList',
      restaurants: 'restaurants',
      defaultStore: 'defaultStore'
    })
  },
  async mounted () {
    this.Reasons = await getapi('selections/invoiceVoidReason')
    await this.getdata()
    this.area = this.defaultStore || this.restaurants[0]
    this.projects = await getapi('selections/projects')
    const salesmans = await getapi('users/local/short')
    this.salesmans = salesmans
  },
  watch: {
    isUpload () { this.getdata() },
    area () { this.getdata() },
    serialNo () { this.getdata() },
    searchText () { this.getdata() },
    range: {
      deep: true,
      immediate: true,
      async handler () {
        console.log('range changed')
        await this.getdata()
      }
    },
    type () { this.getdata() },
    status () { this.getdata() }
  },
  methods: {
    async uploadInvs () {
      await getapi('invoices/sync')
      setTimeout(() => {
        this.getdata()
      }, 3000)
    },
    remitUpdate (ev) {
      const index = this.rows.map(e => e._id).indexOf(ev._id)
      this.rows[index].remitInfo = ev.remitInfo
      this.rows[index].status = ev.status
      this.selected = ev
    },
    update (ev) {
      const index = this.rows.map(e => e._id).indexOf(this.selected._id)
      this.selected = ev
      this.rows.splice(index, 1, ev)
    },
    async updateStatus (index, id, status) {
      const r = await postapi(`restaurant/${id}`, { status })
      this.rows[index].status = r.status
    },
    async getdata () {
      if (this.range) {
        const params = {
          date: this.range.start,
          duration: this.range.duration
        }
        if (this.isUpload) {
          params.isUpload = this.isUpload
        }
        if (this.area) {
          params.store = this.area
        }
        if (this.serialNo !== null) {
          params.sn = this.serialNo
        }
        if (this.status) {
          params.status = this.status
        }
        if (this.project) {
          params.project = this.project
        }
        if (this.searchText) {
          params.search = this.searchText
        }
        if (this.type) {
          params.type = this.type
        }
        console.log(params, 'getrecord')
        const rows = await getapi('restaurant/record?' + new URLSearchParams(params))
        this.rows = rows.data // .filter(e => e.type !== '現場')
        // this.rows = rows.data.filter(e => e.price === 0)
      }
    }
  }

}
</script>
<style lang="scss">
#green.radiobox {
  input[type=radio] {
    min-width: 100px;
    &:checked {
      background-color: #9EAF89;
    }
  }

}
</style>
<style lang="scss" scoped>
td.status {
  text-align: center;
  &.銷售 {
    color: #CC9B6D;
  }
  &.取消 {
    color: #B9B9B9;
  }
  &.作廢 {
    color: #B9B9B9;
  }
  &.折讓 {
    color: var(--折讓);
  }
}
div.status {
  margin: auto;
  width: 100px;
  height: 35px;
  border-radius: 3px;
  font-family: 'Noto Sans TC';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  line-height: 150%;
  display: flex;
  align-items: center;
  color: #FFFFFF;
  justify-content: center;
  &.銷售 {
    background: #CC9B6D;
  }
  &.取消 {
    background-color: #B9B9B9;
  }
  &.作廢 {
    background-color: var(--highlight);
  }
  &.折讓 {
    background-color: var(--折讓);
  }
}
.highlight {
  font-weight: 700;
  color: #FF8B8B;

}
th {
  color: #000000;
}
td {
  font-style: normal;
font-weight: 400;
font-size: 18px;
line-height: 150%;
color: #787878;
  span{
    line-height: 150%;
    font-weight: 400;
    font-size: 18px;
    letter-spacing: 0.1em;
    color: #787878;
  }
}
.viplevel {
  margin-inline: auto;
  &.viplevel-1 {
    width: 27px;
    height: 26px;
    background-image: url(/svg/icon/level1.svg);
  }
  &.viplevel-2 {
    width: 30px;
    height: 25px;
    background-image: url(/svg/icon/level2.svg);
  }
  &.viplevel-3 {
    width: 30px;
    height: 22px;
    background-image: url(/svg/icon/level3.svg);
  }
}
tr.selected {
  background-color: var(--color-base3);
}
.p {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  font-weight: 400;
  font-size: 24px;
  line-height: 35px;
  display: flex;
  align-items: center;
  letter-spacing: 0.1em;
  color: #FFB55F;
  gap: 10px;
  &::before {
    content: '';
    display: inline-block;
    width: 25px;
    height: 25px;
    background-image: url(/svg/icon/points.svg);
  }
}
.statustype {
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;
  letter-spacing: 0.1em;
  width: 65px;
  height: 40px;
  background: #FFFFFF;
  border-radius: 20px;
  display: flex;
  align-items: center;
  justify-content: center;

}
</style>
